@use 'styles/functions/rem' as *;

.cardActionLinkButton {
    align-items: center;
    background: none;
    border: none;
    color: var(--card-action-link-text-color);
    cursor: pointer;
    display: inline-flex;
    gap: rem(4px);
    padding: 0;
}

.cardActionLinkButton:hover {
    text-decoration: underline;
}

.icon {
    height: rem(14px);
    width: rem(14px);
}
